import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DentalRecordsAccess = ({ records, onViewRecord, onDownload }) => {
  const recordCategories = [
    { id: 'lab-results', label: 'Diagnostic Results', icon: 'FlaskConical', count: records?.filter(r => r?.category === 'lab-results')?.length },
    { id: 'imaging', label: 'X-Rays & Imaging', icon: 'Scan', count: records?.filter(r => r?.category === 'imaging')?.length },
    { id: 'visit-summaries', label: 'Visit Summaries', icon: 'FileText', count: records?.filter(r => r?.category === 'visit-summaries')?.length },
    { id: 'immunizations', label: 'Vaccinations', icon: 'Syringe', count: records?.filter(r => r?.category === 'immunizations')?.length },
    { id: 'prescriptions', label: 'Prescriptions', icon: 'Pill', count: records?.filter(r => r?.category === 'prescriptions')?.length },
    { id: 'documents', label: 'Other Documents', icon: 'FolderOpen', count: records?.filter(r => r?.category === 'documents')?.length }
  ];

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric',
      year: 'numeric'
    });
  };

  return (
    <div className="bg-card rounded-xl border border-border p-4 md:p-6">
      <div className="flex items-center gap-3 mb-4 md:mb-6">
        <div className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 bg-primary/10 rounded-lg">
          <Icon name="FolderOpen" size={20} color="var(--color-primary)" />
        </div>
        <div>
          <h2 className="text-lg md:text-xl font-semibold text-foreground">Dental Records</h2>
          <p className="text-xs md:text-sm text-muted-foreground">Access your dental health information</p>
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4 mb-6">
        {recordCategories?.map((category) => (
          <button
            key={category?.id}
            onClick={() => onViewRecord(category?.id)}
            className="bg-background rounded-lg border border-border p-4 transition-smooth hover:shadow-elevation-2 text-left"
          >
            <div className="flex items-center gap-3 mb-2">
              <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg">
                <Icon name={category?.icon} size={20} color="var(--color-primary)" />
              </div>
              <span className="text-2xl font-bold text-foreground">{category?.count}</span>
            </div>
            <p className="text-xs md:text-sm font-medium text-foreground">{category?.label}</p>
          </button>
        ))}
      </div>
      <div className="space-y-2">
        <h3 className="text-sm font-semibold text-foreground mb-3">Recent Records</h3>
        {records?.slice(0, 5)?.map((record) => (
          <button
            key={record?.id}
            onClick={() => onViewRecord(record)}
            className="w-full bg-background rounded-lg border border-border p-4 transition-smooth hover:shadow-elevation-2 text-left"
          >
            <div className="flex items-start gap-3">
              <div className="flex-shrink-0">
                <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                  <Icon name="FileText" size={20} color="var(--color-primary)" />
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-2 mb-1">
                  <h4 className="text-sm md:text-base font-semibold text-foreground truncate">{record?.title}</h4>
                  <span className="text-xs text-muted-foreground whitespace-nowrap">{formatDate(record?.date)}</span>
                </div>
                <p className="text-xs md:text-sm text-muted-foreground mb-2">{record?.provider}</p>
                <div className="flex items-center gap-2">
                  <span className="text-xs font-medium px-2 py-1 rounded bg-muted text-muted-foreground">
                    {record?.categoryLabel}
                  </span>
                  {record?.hasAttachment && (
                    <Button
                      variant="ghost"
                      size="sm"
                      iconName="Download"
                      iconPosition="left"
                      onClick={(e) => {
                        e?.stopPropagation();
                        onDownload(record);
                      }}
                    >
                      <span className="hidden md:inline">Download</span>
                    </Button>
                  )}
                </div>
              </div>
              <Icon name="ChevronRight" size={18} className="text-muted-foreground flex-shrink-0" />
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default DentalRecordsAccess;